import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router-dom'

import { parseLocation, makeLink } from '../../../common/utils/urlHelper'

class FiltersPolygons extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    items: PropTypes.object.isRequired
  }

  constructor (props) {
    super(props)
    const { location: {query} } = props
    this.state = {
      value: query && query.poly_count
        ? query.poly_count
        : ''
    }
  }

  onChange (event) {
    this.setState({value: event.target.value})
  }

  onSubmit () {
    const parsedLocation = parseLocation(this.props.location)

    let nextQuery = Object.assign({}, parsedLocation, {
      poly_count: this.state.value
    })

    delete nextQuery.page

    this.props.history.push(makeLink(nextQuery))
  }

  onEnter (event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.onSubmit()
    }
  }

  componentWillReceiveProps (nextProps) {
    const nextQuery = nextProps.location.query

    if (nextQuery && nextQuery.poly_count !== this.state.value) {
      this.setState({value: nextQuery.poly_count || ''})
    }
  }

  render () {
    const { items } = this.props
    const placeholder = `${items.avg}, ${items.min}-${items.max}`

    return (
      <div className='search-facet--no-margin' id='polygons-filter'>
        <div className='search-facet-box--start'>
          <div className='search-facet-box__inner'>
            <h2 className='search-facet-box__heading'>
              <i className='e-icon -icon-polygon -margin-right' />
              Polygons
            </h2>
            <div className='search-facet-range__inputs'>
              <div className='search-facet-range__input--single'>
                <label
                  className='fds-u-is-visually-hidden'
                  htmlFor='poly_count'>
                  Polygons
                </label>
                <input
                  type='text'
                  id='poly_count'
                  className='e-input'
                  placeholder={placeholder}
                  pattern='(\d+\s*\-\s*\d+|\d+)'
                  value={this.state.value}
                  onChange={this.onChange.bind(this)}
                  onKeyPress={this.onEnter.bind(this)} />
              </div>
              <div className='search-facet-range__input--submit'>
                <button type='button' className='fds-c-button fds-u-p0' onClick={this.onSubmit.bind(this)}>
                  <i className='e-icon -icon-search'>
                    <span className='e-icon__alt'>Apply</span>
                  </i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export const FiltersPolygonsComponent = FiltersPolygons
export default withRouter(FiltersPolygons)



// WEBPACK FOOTER //
// ./client/components/filters/filtersPolygons.js